import React from "react";
import PostItem from "../PostItem";
import EventItem from "../EventItem";

const FeedItem = ({ item }) =>
    item.kind === "text" ? <PostItem post={item} /> : <EventItem event={item} />;

export default FeedItem;
